/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Item_Export_FullInputs */



/**
* | output |
* | --- |
* | "Export (with original values)" |
*
* @param {Chat_Item_Export_FullInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_item_export_full = /** @type {((inputs?: Chat_Item_Export_FullInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Item_Export_FullInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Exportieren (mit Originalwerten)")
	return /** @type {LocalizedString} */ ("Export (with original values)")
});